import {Component, input, output, signal} from "@angular/core";
import {TranslationKey} from "@models";
import {explicitEffect} from "ngxtension/explicit-effect";
import {SimButton} from "@common/ui/button/sim-button.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
	selector: "sim-new-list-item",
	templateUrl: "./new-list-item.component.html",
	styleUrl: "./new-list-item.component.scss",
	imports: [SimButton, TranslateModule],
})
export class NewListItemComponent {
	public readonly primaryLabel = input.required<TranslationKey>();
	public readonly buttonLabel = input.required<TranslationKey>();
	public readonly secondaryLabel = input<TranslationKey | null>(null);
	public readonly disabled = input<boolean>(false);
	public readonly add = output<void>();

	// Button variant
	public readonly inputButtonVariant = input<"primary" | "secondary">("primary", {alias: "buttonVariant"});
	public readonly buttonVariant = signal<"primary" | "secondary">("primary");
	readonly #setButtonVariant = explicitEffect([this.inputButtonVariant], () => this.buttonVariant.set(this.inputButtonVariant()));
}
